import NotificationService from './notification';

let notifications = [];

const addNotification = (id) => {
    notifications.push(id);
};

const closeAllNotifications = () => {
    notifications.forEach((notification) => {
        NotificationService.close(notification);
    });
    notifications = [];
};

export { addNotification, closeAllNotifications };
